import React from "react";
import numberWithCommas from '../common/number';
import FontAwesome from "react-fontawesome";

const RenderRegisterList = ({ list,lastBookElementRef,handleChange }) => {
//console.log(list);
  return (
    <>
      {list &&
        
        list.map((item,index) => {
          if (list.length === index +1)
         
        { return (

        
            <div   key={item.No}>
              <div className="card  m-1 ">
               
                  <div ref = {lastBookElementRef}  className="row m-1">
                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1 ">
                      <div style={{ fontSize: "22px" }}>
                        <span className="badge rounded-pill bg-primary">
                          {item.No}
                        </span>
                      </div>
                      <div style={{ fontSize: "14px" }}>{item.Weight_no}</div>
                      <div style={{ fontSize: "14px" }}>
                        {item.Customer_Name}
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        {item.CustomerTypeName}
                      </div>
                    </div>
                    
                

                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          ใบนำส่ง :
                          <small style={{ fontSize: "14px" }}> {item.Delivery_No}</small>{" "}
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          วัตถุประสงค์ :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            
                            {item.aim_name}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ประเภทสินค้า :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.type_name}
                          </small>
                        </h6>
                      </div>

                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          สินค้า :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.ProductName}
                          </small>
                        </h6>
                      </div>
                      <div></div>
                    </div>
                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ประเภทรถ :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.truckType}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ทะเบียนหัว :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.First_Driven_NO}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ทะเบียนหาง :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.Second_driven_no}
                          </small>
                        </h6>
                      </div>
                    
                    </div>

                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div>
                          <h6>
                            {" "}
                            เข้า :
                            <small style={{ fontSize: "18px" }}>
                              {" "}
                              <span className="badge rounded-pill bg-info text-dark">
                               
                                {numberWithCommas(item.receive_weightin)} 
                              </span>
                            </small>
                          </h6>
                        </div>
  
                        <div>
                          <h6>
                            {" "}
                            ออก :
                            <small style={{ fontSize: "18px" }}>
                              {" "}
                              <span className="badge rounded-pill bg-warning text-dark">
                              {numberWithCommas(item.receive_weightout)} 
                              
                              </span>
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            {" "}
                            หัก :
                            <small style={{ fontSize: "18px" }}>
                              {" "}
                              <span className="badge rounded-pill bg-danger">
                              {numberWithCommas(item.weightcut)}  
                              </span>
                            </small>
                          </h6>
                        </div>

                        <div>
                          <h6>
                            {" "}
                            สุทธิ :
                            <small style={{ fontSize: "18px" }}>
                              {" "}
                              <span className="badge rounded-pill bg-success">
                              {numberWithCommas(item.receive_weightnet)}  
                              </span>
                            </small>
                          </h6>
                        </div>
                    </div>

                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                      
                    <div style={{ fontSize: "13px" }}>
                        <h6>
                          {" "}
                          เวลาชั่งเข้า :
                            <small style={{ fontSize: "13px" }}>
                              {" "}
                              {item.DateIn}
                          </small>
                        </h6>
                      </div>

                    <div style={{ fontSize: "13px" }}>
                        <h6>
                        {" "}
                          เวลาชั่งออก :
                            <small style={{ fontSize: "13px" }}>
                              {" "}
                              {item.DateOut}
                          </small>
                        </h6>
                      </div>

                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          สถานที่ลง :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.store_name}
                          </small>
                        </h6>
                      </div>

                  
                    </div>
                    <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                     
                     <div style={{ fontSize: "13px" }}>
                       <h6 style={{ fontSize: "13px" }}>
                         {" "}
                       รูปขาเข้า: {" "}
                          <button
                           className="m-1 btn btn-primary btn-sm"
                           onClick={() =>
                             handleChange(item.Weight_no,'IN',1)
                           }
                         >1
                           <FontAwesome name="camera" />
                         </button>
                         <button
                           className="m-1 btn btn-primary btn-sm"
                           onClick={() =>
                             handleChange(item.Weight_no,'IN',2)
                           }
                         >2
                           <FontAwesome name="camera" />
                         </button>
                         <button
                           className="m-1 btn btn-primary btn-sm"
                           onClick={() =>
                             handleChange(item.Weight_no,'IN',3)
                           }
                         >3
                           <FontAwesome name="camera" />
                         </button>

                       </h6>
                       
                     </div>
                  
                     <div style={{ fontSize: "13px" }}>
                       <h6 style={{ fontSize: "13px" }}>
                         {" "}
                       รูปขาออก:
                          <button
                           className="m-1 btn btn-success btn-sm"
                           onClick={() =>
                             handleChange(item.Weight_no,'OUT',1)
                           }
                         >
                         1
                           <FontAwesome name="camera"/>
                         </button>
                         <button
                           className="m-1 btn btn-success btn-sm"
                           onClick={() =>
                             handleChange(item.Weight_no,'OUT',2)
                           }
                         > 2
                           <FontAwesome name="camera" />
                         </button>
                         <button
                           className="m-1 btn btn-success btn-sm"
                           onClick={() =>
                             handleChange(item.Weight_no,'OUT',3)
                           }
                         >3
                           <FontAwesome name="camera" />
                         </button>
                       </h6>
                       
                     </div>
                  
                   </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
          
         
        )} else 
        {
          return (

        
              <div  key={item.No}>
                <div className="card  m-2">
                  {/* <div className="card-body"> */}
                    <div className="row m-1">
                      <div className=" col-xs-6 col-sm-4 col-md-2 lg-1 ">
                        <div style={{ fontSize: "22px" }}>
                          <span className="badge rounded-pill bg-primary">
                            {item.No}
                          </span>
                        </div>
                        <div style={{ fontSize: "14px" }}>{item.Weight_no}</div>
                        <div style={{ fontSize: "14px" }}>
                          {item.Customer_Name}
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {item.CustomerTypeName}
                        </div>
                      </div>
  
              
  
                      <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                        <div style={{ fontSize: "14px" }}>
                          <h6>
                            ใบนำส่ง :
                            <small style={{ fontSize: "14px" }}> {item.Delivery_No}</small>{" "}
                          </h6>
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          <h6>
                            {" "}
                            วัตถุประสงค์ :
                            <small style={{ fontSize: "14px" }}>
                              {" "}
                              {item.aim_name}
                            </small>
                          </h6>
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          <h6>
                            {" "}
                            ประเภทสินค้า :
                            <small style={{ fontSize: "14px" }}>
                              {" "}
                              {item.type_name}
                            </small>
                          </h6>
                        </div>
  
                        <div style={{ fontSize: "14px" }}>
                          <h6>
                            {" "}
                            สินค้า :
                            <small style={{ fontSize: "14px" }}>
                              {" "}
                              {item.ProductName}
                            </small>
                          </h6>
                        </div>
                        <div></div>
                      </div>
                      <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                        <div style={{ fontSize: "14px" }}>
                          <h6>
                            {" "}
                            ประเภทรถ :
                            <small style={{ fontSize: "14px" }}>
                              {" "}
                              {item.truckType}
                            </small>
                          </h6>
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          <h6>
                            {" "}
                            ทะเบียนหัว :
                            <small style={{ fontSize: "14px" }}>
                              {" "}
                              {item.First_Driven_NO}
                            </small>
                          </h6>
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          <h6>
                            {" "}
                            ทะเบียนหาง :
                            <small style={{ fontSize: "14px" }}>
                              {" "}
                              {item.Second_driven_no}
                            </small>
                          </h6>
                        </div>
                     
                      </div>
  
                      <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                        <div>
                          <h6>
                            {" "}
                            เข้า :
                            <small style={{ fontSize: "18px" }}>
                              {" "}
                              <span className="badge rounded-pill bg-info text-dark">
                               
                                {numberWithCommas(item.receive_weightin)} 
                              </span>
                            </small>
                          </h6>
                        </div>
  
                        <div>
                          <h6>
                            {" "}
                            ออก :
                            <small style={{ fontSize: "18px" }}>
                              {" "}
                              <span className="badge rounded-pill bg-warning text-dark">
                              {numberWithCommas(item.receive_weightout)} 
                              
                              </span>
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            {" "}
                            หัก :
                            <small style={{ fontSize: "18px" }}>
                              {" "}
                              <span className="badge rounded-pill bg-danger">
                              {numberWithCommas(item.weightcut)}  
                              </span>
                            </small>
                          </h6>
                        </div>

                        <div>
                          <h6>
                            {" "}
                            สุทธิ :
                            <small style={{ fontSize: "18px" }}>
                              {" "}
                              <span className="badge rounded-pill bg-success">
                              {numberWithCommas(item.receive_weightnet)}  
                              </span>
                            </small>
                          </h6>
                        </div>
                      </div>
  
                      <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "13px" }}>
                          <h6>
                            {" "}
                          เวลาชั่งเข้า :
                            <small style={{ fontSize: "13px" }}>
                              {" "}
                              {item.DateIn}
                            </small>
                          </h6>
                        </div>
                        <div style={{ fontSize: "13px" }}>
                          <h6>
                            {" "}
                          เวลาชั่งออก :
                            <small style={{ fontSize: "13px" }}>
                              {" "}
                              {item.DateOut}
                            </small>
                          </h6>
                        </div>
                      <div style={{ fontSize: "14px" }}>
                          <h6>
                            {" "}
                            สถานที่ลง :
                            <small style={{ fontSize: "14px" }}>
                              {" "}
                              {item.store_name}
                            </small>
                          </h6>
                        </div>
                     
                      </div>

                      <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                     
                        <div style={{ fontSize: "13px" }}>
                          <h6 style={{ fontSize: "13px" }}>
                            {" "}
                          รูปขาเข้า: {" "}
                             <button
                              className="m-1 btn btn-primary btn-sm"
                              onClick={() =>
                                handleChange(item.Weight_no,'IN',1)
                              }
                            >1
                              <FontAwesome name="camera" />
                            </button>
                            <button
                              className="m-1 btn btn-primary btn-sm"
                              onClick={() =>
                                handleChange(item.Weight_no,'IN',2)
                              }
                            >2
                              <FontAwesome name="camera" />
                            </button>
                            <button
                              className="m-1 btn btn-primary btn-sm"
                              onClick={() =>
                                handleChange(item.Weight_no,'IN',3)
                              }
                            >3
                              <FontAwesome name="camera" />
                            </button>

                          </h6>
                          
                        </div>
                     
                        <div style={{ fontSize: "13px" }}>
                          <h6 style={{ fontSize: "13px" }}>
                            {" "}
                          รูปขาออก:
                             <button
                              className="m-1 btn btn-success btn-sm"
                              onClick={() =>
                                handleChange(item.Weight_no,'OUT',1)
                              }
                            >
                            1
                              <FontAwesome name="camera"/>
                            </button>
                            <button
                              className="m-1 btn btn-success btn-sm"
                              onClick={() =>
                                handleChange(item.Weight_no,'OUT',2)
                              }
                            > 2
                              <FontAwesome name="camera" />
                            </button>
                            <button
                              className="m-1 btn btn-success btn-sm"
                              onClick={() =>
                                handleChange(item.Weight_no,'OUT',3)
                              }
                            >3
                              <FontAwesome name="camera" />
                            </button>
                          </h6>
                          
                        </div>
                     
                      </div>
                    </div>
                  {/* </div> */}
                </div>
              </div>
             
           
          )

        }}

        
        )}
    </>
  );
};

export default RenderRegisterList;
